/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ maxCps: NonNullable<unknown> }} Summary_Max_Cps_TitleInputs */



/**
* | output |
* | --- |
* | "Max CPS: {maxCps}" |
*
* @param {Summary_Max_Cps_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const summary_max_cps_title = /** @type {((inputs: Summary_Max_Cps_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Summary_Max_Cps_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`CPS Max: ${i?.maxCps}`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Max CPS: ${i?.maxCps}`)
	if (locale === "it") return /** @type {LocalizedString} */ (`CPS massimo: ${i?.maxCps}`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Максимальное количество CPS: ${i?.maxCps}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`CPS máximo: ${i?.maxCps}`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`最大 CPS：${i?.maxCps}`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`最大CPS: ${i?.maxCps}`)
	if (locale === "hi") return /** @type {LocalizedString} */ ("अधिकतम सीपीएस: __पीएच_0__")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`CPS máximo: ${i?.maxCps}`)
	return /** @type {LocalizedString} */ (`Max CPS: ${i?.maxCps}`)
});